try {
  let videoPopUp = document.querySelector(".our-story__popup");
  let videoPopUpOpen = document.querySelector(".js-our-story__popup-open");
  let videoPopUpClose = document.querySelectorAll(".js-our-story__popup-close");
  let mobileNavigation = document.querySelector(".navigation-mobile");
  let menuIcon = document.querySelector(".menu-icon");

  videoPopUpOpen.addEventListener("click", () => {
    videoPopUp.classList.add("open");
    mobileNavigation.classList.add("open--no-height");
    menuIcon.classList.add("open");
    menuIcon.classList.add("white");
  });

  Array.from(videoPopUpClose).forEach((item) => {
    item.addEventListener("click", () => {
      menuIcon.classList.remove("open");
      menuIcon.classList.remove("white");
      videoPopUp.classList.remove("open");
      mobileNavigation.classList.remove("open--no-height");
    });
  });

  menuIcon.addEventListener("click", (e) => {
    if (e.currentTarget.classList.contains("white")) {
      menuIcon.classList.remove("white");
      menuIcon.classList.remove("open");
      videoPopUp.classList.remove("open");
      mobileNavigation.classList.remove("open--no-height");
    }
  });

  videoPopUp.addEventListener("click", (e) => {
    if (e.target.parentNode.closest(".our-story__popup-video") === null) {
      menuIcon.classList.remove("white");
      menuIcon.classList.remove("open");
      videoPopUp.classList.remove("open");
      mobileNavigation.classList.remove("open--no-height");
    }
  });
} catch (err) {
  console.log(err);
}
